import http from '../../../Utils/http';
const GetListOfStripeUsers = {
  name: 'getListOfStripeUsers',
  state: {
    loading: false,
    error: '',
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
    stripeUsers: []
  },
  reducers: {
    getListOfStripeUsersRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        stripeUsers: []
      };
    },
    getListOfStripeUsersReceived(state, payload) {
      return {
        ...state,
        loading: false,
        stripeUsers: payload,
        error: '',
      }
    },
    getListOfStripeUsersRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        stripeUsers: [],
        loading: false,
      };
    },

  },
  effects: (dispatch) => ({
    async requesttoGetListOfStripeUsers() {
      try {
        this.getListOfStripeUsersRequested();
        const response = await http.get(`savvy/users/dso`);
        this.getListOfStripeUsersReceived(response.data.data);
      } catch (err) {
        this.getListOfStripeUsersRequestFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
  }),
};

export default GetListOfStripeUsers;